import { lowerFirst, mapValues } from "lodash-es";
import type {
	CalculatorAccessItem,
	CalculatorAccessMap,
} from "web_myplann/Calculators/Types/CalculatorAccess";
import { CALCULATOR_TYPE_ENUMS } from "web_myplann/Calculators/Utils/calculatorCatalog";

export const mapCalculatorAccess = (
	items: CalculatorAccessItem[],
): CalculatorAccessMap => {
	const byType = new Map<string, CalculatorAccessItem>(
		items.map((item) => [lowerFirst(item.calculatorType), item]),
	);

	return mapValues(CALCULATOR_TYPE_ENUMS, (_typeEnum, type) => {
		const item = byType.get(type);

		return {
			isVisible: item?.show ?? false,
			hasAccess: item?.access ?? false,
		};
	});
};
